module.exports = "/images/bn.svg";